<div
  [ngClass]="{
    'cart-product': true,
  }"
  *ngIf="{
    entry: entry(),
    disabled: disabled(),
    onCheckout: onCheckout(),
    hideQuantity: hideQuantity(),
  } as content"
>
  <div class="cart-product-content">
    <div class="cart-product-content-data">
      <div class="cart-product-content-data-wrapper">
        <cx-media [media]="entryImage()" />

        <div class="cart-product-content-data-wrapper-container">
          <a [routerLink]="['/produto/', content.entry.productCode, content.entry.productName]">
            <span class="cart-product-content-data-wrapper-container-title">{{ content.entry.productName }}</span>
          </a>

          <div class="cart-product-content-data-wrapper-container-description">
            <strong>{{ 'product.ean' | translate }}</strong>
            <span>{{ content.entry.productEan }}</span>
          </div>

          <div class="cart-product-content-data-wrapper-container-info">
            <!-- <span>Reckitt Benckiser</span>
            <span>/</span>
            <span>OTC</span> -->
          </div>

          <div class="cart-product-content-data-wrapper-container-price">
            @if (content.entry.basePrice.formattedValue) {
              <div class="d-flex flex-column gap-1">
                <!-- Base unit price -->
                <div class="d-flex align-items-center flex-wrap gap-2">
                  <div class="d-flex align-items-baseline gap-1">
                    <strong
                      [ngClass]="{
                        'price-final': !((content.entry.discount?.value ?? 0) > 0),
                        'price-final fs-6 text-decoration-line-through text-muted': (content.entry.discount?.value ?? 0) > 0,
                      }"
                      >{{ content.entry.basePrice.formattedValue }}</strong
                    >
                    <span class="price-label small text-muted">/ UN</span>
                  </div>

                  <!-- Discount badge -->
                  @if ((content.entry.discount?.value ?? 0) > 0) {
                    <span
                      class="badge rounded-pill d-inline-flex align-items-center gap-1 px-2 py-1"
                      style="background: #e8f5e9; color: #2e7d32; border: 1px solid #c8e6c9; font-size: 0.7rem; font-weight: 600"
                    >
                      <span class="material-symbols-outlined" style="font-size: 12px">local_offer</span>
                      −{{ content.entry.discount?.formattedValue }}
                    </span>
                  }
                </div>
              </div>
            } @else {
              <strong>{{ 'product.price.unavailable' | translate }}</strong>
            }

            @if (taxItems().length > 0) {
              <div class="cart-product-tax-summary">
                <span class="material-symbols-outlined">receipt_long</span>
                <strong>{{ 'product.price.taxes' | translate }}</strong>
                @for (tax of taxItems(); track tax.label) {
                  <span class="cart-product-tax-summary__item">{{ tax.label }} {{ tax.formattedValue }}</span>
                }
              </div>
            }
          </div>
        </div>
      </div>

      <div class="cart-product-content-data-stock">
        <!-- <cx-tag [size]="'sm' " [type]="'neutral'" [variant]="'outline'"><strong>CD:</strong> CD PR/PR</cx-tag> -->
      </div>
    </div>

    <div class="cart-product-content-table">
      <div class="cart-product-footer-actions">
        @if (!content.onCheckout) {
          <cx-input-quantity
            *ngIf="!content.hideQuantity"
            label="Qtde"
            [formControl]="quantity"
            [min]="0"
            [allowDeleteOnMin]="true"
            (delete)="confirmDeleteProduct()"
          />
        } @else {
          <div class="cart-product-footer-table">
            <span>{{ 'cart.product.quantity.title' | translate }}</span>

            <div class="cart-product-footer-table-data">
              <div class="table-column">
                <span>{{ 'cart.product.quantity.solicitation' | translate }}</span>
                <span>{{ content.entry.qty }}</span>
              </div>
              <div class="table-column">
                <span>{{ 'cart.product.quantity.attended' | translate }}</span>
                <span>0</span>
              </div>
              <div class="table-column">
                <span>{{ 'cart.product.quantity.missing' | translate }}</span>
                <span>0</span>
              </div>
            </div>
          </div>
        }
      </div>

      <div class="cart-product-footer-total">
        <span>{{ 'cart.product.totalNF' | translate }}</span>
        <span>{{ content.entry.totalPrice.formattedValue }}</span>
      </div>

      @if (!content.disabled && !content.onCheckout) {
        <button (click)="confirmDeleteProduct()" [attr.title]="'cart.product.delete' | translate" class="cart-product-delete">
          <span class="material-symbols-outlined">delete</span>
        </button>
      }

      @if (content.entry.pricingData) {
        <div class="cart-product-content-table-data">
          <div class="table-column">
            <span>{{ 'product.price.factory' | translate }}</span>
            <span>{{ content.entry.pricingData.formatedPrice }}</span>
          </div>
          <div class="table-column">
            <span>{{ 'product.price.pmc' | translate }}</span>
            <span>R$ -</span>
          </div>
          @for (tax of taxItems(); track tax.label) {
            <div class="table-column">
              <span>{{ tax.label }}</span>
              <span>{{ tax.formattedValue }}</span>
            </div>
          }
          <div class="table-column">
            <span>{{ 'product.price.repasse' | translate }}</span>
            <span>R$ -</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
